import React from 'react';
import { FaCalendarWeek, FaCalendarAlt, FaCalendarDay, FaUmbrellaBeach, FaSyringe, FaBan } from 'react-icons/fa';

export default function StatScrollRow({ stats }) {
    const {
        weekPlanned = 0,
        monthPlanned = 0,
        quarterPlanned = 0,
        yearPlanned = 0,
        availability30d = 0,
        annualLeaveLeft = 0,
        sickDaysUsed = 0,
        cancelledShifts = 0,
        cancelledLeave = 0
    } = stats || {};

    const StatCard = ({ icon, label, value, unit, color }) => (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#ffffff',
            border: `1px solid ${color}33`,
            borderRadius: '8px',
            padding: '12px 16px',
            minWidth: '150px',
            flexShrink: 0,
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
            <div style={{ color, fontSize: '20px', marginRight: '12px' }}>
                {icon}
            </div>
            <div>
                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>
                    {label}
                </div>
                <div style={{ fontSize: '16px', fontWeight: 'bold', color }}>
                    {value}<span style={{ fontSize: '12px', fontWeight: '500', marginLeft: '2px' }}>{unit}</span>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{
            display: 'flex',
            gap: '12px',
            overflowX: 'auto',
            paddingBottom: '12px',
            marginBottom: '16px',
            // hide scrollbar cross-browser
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
        }}>
            <style>
                {`
                ::-webkit-scrollbar {
                    display: none;
                }
                `}
            </style>
            
            <StatCard icon={<FaCalendarWeek />} label="Week planned" value={weekPlanned.toFixed(1)} unit="h" color="#0056b3" />
            <StatCard icon={<FaCalendarAlt />} label="Month planned" value={monthPlanned.toFixed(1)} unit="h" color="#3b82f6" />
            <StatCard icon={<FaCalendarDay />} label="Quarter" value={quarterPlanned.toFixed(1)} unit="h" color="#8b5cf6" />
            <StatCard icon={<FaCalendarAlt />} label="Year" value={yearPlanned.toFixed(1)} unit="h" color="#10b981" />
            
            <StatCard icon={<FaCalendarDay />} label="Availability 30d" value={availability30d} unit="" color="#22c55e" />
            
            <StatCard icon={<FaUmbrellaBeach />} label="Annual leave left" value={annualLeaveLeft.toFixed(1)} unit="d" color="#f59e0b" />
            <StatCard icon={<FaSyringe />} label="Sick days used" value={sickDaysUsed.toFixed(1)} unit="d" color="#ef4444" />
            
            <StatCard icon={<FaBan />} label="Cancelled shifts" value={cancelledShifts} unit="" color="#ef4444" />
            <StatCard icon={<FaBan />} label="Cancelled leave" value={cancelledLeave} unit="" color="#f97316" />
        </div>
    );
}
